import './partials-js/refs';
import './partials-js/vars';
import './partials-js/requestGet';
import './partials-js/onLoadPage';
import './partials-js/themeSwitch';
import './partials-js/slider';
import './partials-js/authorization';
import './partials-js/search-movie-word';
import './partials-js/makeRenderFilms';
import './partials-js/openModal';
import './partials-js/addToWatch';
import './partials-js/tuiPagination';
import './partials-js/footer-modal';
import './partials-js/buttonToTop';
import '../node_modules/basiclightbox/dist/basicLightbox.min.css';
import './partials-js/closePreloader';

import './partials-js/requestGet';

import { onLoadPage } from './partials-js/onLoadPage';

document.addEventListener('DOMContentLoaded', onLoadPage());

// import {

//   addWatchedtoLocalStorage,
//   addQueuedToLocalStorage,
// } from './partials-js/addToWatch';

// addQueuedToLocalStorage();
// addWatchedtoLocalStorage();
